import { Uploader } from '../../../../wrapped-cube-client';
import { selectors__unoptimized as selectors } from '../../../ducks/resource-edges';
import { actionCreators as nodeActionCreators } from '../../../ducks/resource-nodes';
import { addFileStub } from './addFileStub';
import { continueNestedUpload } from './continueNestedUpload';
import { createNestedUpload } from './createNestedUpload';
import { selectors as nodeSelectors } from '../../../ducks/resource-nodes';
import { normalizeFiles } from './normalizeFiles';
import { setTimeoutMaybe } from './setTimeoutMaybe';
import { ResourceIdentifier } from '@cube3/common/model/resource-types';

export const uploadFilesToParentResource = ({
  dispatch,
  getState,
  workspaceId,
  action,
  edgeLabel = 'assets'
}) => {
  // iterate over the files
  const files = normalizeFiles(action.payload.files, action.payload.metadata);
  const parentResource =
    action.payload.parentResource ||
    ({
      type: 'folder',
      id: action.payload.parentFolderId
    } as ResourceIdentifier);
  const now = Date.now();

  files
    .map((f, idx) => {
      // this is just a placeholder,
      // will get overriden once the actual tus download is created
      addFileStub(
        f,
        parentResource,
        dispatch,
        getState,
        now + idx * 400,
        workspaceId
      );
      return f;
    })
    .forEach((file, idx) =>
      // we check for resumable uploads
      Uploader.getResumableFromParent(file, {
        targetId: 'fake',
        targetType: 'fake',
        ancestorId: parentResource.id,
        ancestorType: parentResource.type,
        resumeContext: 'ancestor',
        workspace: getState().session.workspace
      }).then((resumables: { metadata: any }[]) => {
        let anyResumed;

        resumables.forEach(({ metadata }, idx) => {
          let asset, upload;

          /** Try to find the asset matching the resumable upload
           *  NOTE: only works if assets are already retrieved (so when visiting folder)
           */
          if (metadata) {
            const assets = selectors.getResourceEdgesByLabel(
              getState(),
              metadata.ancestorResourceId,
              metadata.ancestorResourceType,
              edgeLabel,
              'asset'
            );
            asset = assets.find((a) => a.id === metadata.targetResourceId);

            upload = nodeSelectors.getResourceById(
              getState(),
              'file-upload',
              metadata.id
            );
          }

          if (metadata && asset && !upload?.tusUpload) {
            // if there's a resumable upload + asset resource pair
            // we can skip creating a new asset
            continueNestedUpload(
              { ...file, id: metadata.id },
              metadata,
              parentResource,
              dispatch,
              getState,
              idx
            );
            dispatch(
              nodeActionCreators.disposeResource('file-upload', file.id, true)
            );
            anyResumed = true;
          }
        });

        if (!anyResumed) {
          // no existing resumable + asset pair
          setTimeoutMaybe(() => {
            createNestedUpload(
              file,
              parentResource,
              dispatch,
              edgeLabel,
              workspaceId
            );
          }, idx * 400);
        }
      })
    );
};
